const memoize = (func) => {
    const results = {};
    return (...args) => {
        const argsKey = JSON.stringify(args);
        if (!results[argsKey]) {
            results[argsKey] = func(...args);
        }
        return results[argsKey];
    };
};

const processResponse = memoize((str, substitutions) => {
    try {
        var find = ['{"', '"}', "{'", "'}", '{/}', '{}', '{', '}', '{/a}', '<<', '>>', '<%', '%>', '\"', '{{', '}}'];
        var replaceWith = ['<div class="', '">', "<div class='", "'>", '</div>', '<div>', '<', '>', '</a>', '{', '}', '{%', '%}', '"','{', '}'];

        if (typeof substitutions !== undefined) {
            for (const key in substitutions) {

                if (substitutions.hasOwnProperty(key)) {
                    find.push(`{%=${key}}`, `{{%=${key}}}`, `{%=${key}>`, `{%=${key}%}`);
                    const element = substitutions[key];

                    replaceWith.push(element, element, element);
                }
            }
        }

        var replaceString = str;

        for (var i = 0; i < find.length; i++) {
            replaceString = replaceString !== null ? replaceString.split(find[i]).join(replaceWith[i]) : "";
        }
        return replaceString;
    } catch (error) {
        // console.log("Exception: while process response:_", error);
    }
});

const stringFormat = (str, currentCount, totalCount, singularForm, pluralForm, substitutions, activePageNumber, lastPageNumber) => {
    try {

        var find = [
            '{{0}}',
            '{{1}}',
            '{0}',
            '{1}',
            '{2}',
            '{%=AnsweredCount}',
            '{%=TotalCount}',
            '{%=UnansweredCount}',
            '{{%=PercentComplete}}',
            '{%=ActivePageNumber%}',
            '{%=LastPageNumber%}',
            '{{',
            '}}'
        ];

        var replaceWith = [
                currentCount,
                totalCount,
                currentCount,
                totalCount,
                currentCount === 1 ? singularForm : pluralForm,
                currentCount,
                totalCount,
                currentCount,
                totalCount,
                activePageNumber,
                lastPageNumber,
                '{',
                '}'
            ];

         if (typeof substitutions !== undefined) {
            for (const key in substitutions) {
                if (substitutions.hasOwnProperty(key)) {
                    find.push(`{%=${key}}`, `{{%=${key}}}`);
                    const element = substitutions[key];
                    replaceWith.push(element, element);
                }
            }
        }

        for (var i = 0; i < find.length; i++) {
            str = str !== null ? str.split(find[i]).join(replaceWith[i]) : "";
        }
        // console.log(str);
        return str;
    } catch (error) {
        console.log("Exception: while string format response:_", error);
    }
}

const redirectionUrl = (str, substitutions) => {
    try {
        var find = ['{{', '}}'];
        var replaceWith = ['{', '}'];

        for (const key in substitutions) {
            if (substitutions.hasOwnProperty(key)) {
                const element = substitutions[key];
                find.push(`{%=${key}}`, `{{%=${key}}}`);
                replaceWith.push(element, element);
            }
        }


        var finalStr = str;

        for (var i = 0; i < find.length; i++) {
            // var tempFind = find[i].replace(/[^a-zA-Z ]/g, "");

            // console.log(find[i])
            // for (const key in substitutions) {
            //     if (substitutions.hasOwnProperty(key)) {
            //         const element = substitutions[key];

            //         if (key === tempFind.toLowerCase()) {
            //             console.log(element)
            //             finalStr = finalStr !== null ? finalStr.split(find[i]).join(element) : "";
            //         }
            //     }
            // }
            finalStr = finalStr !== null ? finalStr.split(find[i]).join(replaceWith[i]) : "";
        }

        return finalStr;
    } catch (error) {
        console.log("Exception: while redirectionUrl response:_", error);
    }
}

const numberFormat = (str, currentCount, singularForm, pluralForm) => {
    try {
        var find = [
            '{{%=AnsweredCount}}',
            '{{%=IsOrAre}}',
            '{{%=NaCount}}',
            '{{%=UnansweredCount}}',
            '{{%=UnansweredRequiredCount}}'
        ];
        var replaceWith = [
            `{strong}${currentCount}{strong}`,
            `{span style='font-weight:300;color:#5F5F5F'}${currentCount === 1 ? singularForm : pluralForm }{/span}`,
            `{strong}${currentCount}{strong}`,
            `{strong}${currentCount}{strong}`,
            `{strong}${currentCount}{strong}`,
        ];

        for (var i = 0; i < find.length; i++) {
            str = str !== null ? str.split(find[i]).join(replaceWith[i]) : "";
        }

        return str;
    } catch (error) {
        console.log("Exception: while number format response:_", error);
    }
}

const openEndStringFormat = (str, remainingCharacters, charactersUsed, totalAllowedCharacters) => {
    try {
        var find = [
            '{{%=RemainingCharacters}}',
            '{{%=CharactersUsed}}',
            '{{%=TotalAllowedCharacters}}'
        ];
        var replaceWith = [
            remainingCharacters,
            charactersUsed,
            totalAllowedCharacters
        ];

        for (var i = 0; i < find.length; i++) {
            str = str !== null ? str.split(find[i]).join(replaceWith[i]) : "";
        }

        return str;
    } catch (error) {
        console.log("Exception: while open end string format response:_", error);
    }
}

const processItemResponse = (itemKey, responseSet, itemResponses, itemType, dataCollectionGuid, putAllForItemCollection, eventType) => {
    try {
        responseSet.itemKey              = itemKey;
        responseSet.alternateItemId      = null;
        responseSet.lastUpdatedOn        = null;
        responseSet.responseTime         = null;
        responseSet.itemResponses        = itemType !== "101" || itemType !== "102" ? itemResponses : [];
        responseSet.demographicResponses = itemType === "101" || itemType === "102"  ? itemResponses : [];
        responseSet.serverStatus         = 0;
        responseSet.hasPosted            = 0;
        if (putAllForItemCollection && putAllForItemCollection !== undefined) {

           if(eventType == "onChange" && putAllForItemCollection[itemKey + dataCollectionGuid].dataCollectionGuid == dataCollectionGuid){
                putAllForItemCollection[itemKey + dataCollectionGuid].itemKey              = itemKey;
                putAllForItemCollection[itemKey + dataCollectionGuid].alternateItemId      = null;
                putAllForItemCollection[itemKey + dataCollectionGuid].lastUpdatedOn        = null;
                putAllForItemCollection[itemKey + dataCollectionGuid].responseTime         = null;
                putAllForItemCollection[itemKey + dataCollectionGuid].itemResponses        = itemType !== "101" || itemType !== "102" ? itemResponses : [];
                putAllForItemCollection[itemKey + dataCollectionGuid].serverStatus         = 0;
                putAllForItemCollection[itemKey + dataCollectionGuid].hasPosted            = 0;
                putAllForItemCollection[itemKey + dataCollectionGuid].demographicResponses = itemType === "101" || itemType === "102"  ? itemResponses : [];
                putAllForItemCollection[itemKey + dataCollectionGuid].dataCollectionGuid   = dataCollectionGuid;
                responseSet.dataCollectionGuid  = dataCollectionGuid;
            } else {
                if(putAllForItemCollection[itemKey + dataCollectionGuid] == undefined){
                    responseSet.dataCollectionGuid  = dataCollectionGuid !== undefined ? dataCollectionGuid : null;
            putAllForItemCollection[itemKey + dataCollectionGuid] = responseSet;
                } else {
                    if(eventType == "onLoad" && putAllForItemCollection[itemKey + dataCollectionGuid].dataCollectionGuid == dataCollectionGuid){
                        putAllForItemCollection[itemKey + dataCollectionGuid].itemKey              = itemKey;
                        putAllForItemCollection[itemKey + dataCollectionGuid].alternateItemId      = null;
                        putAllForItemCollection[itemKey + dataCollectionGuid].lastUpdatedOn        = null;
                        putAllForItemCollection[itemKey + dataCollectionGuid].responseTime         = null;
                        putAllForItemCollection[itemKey + dataCollectionGuid].itemResponses        = itemType !== "101" || itemType !== "102" ? itemResponses : [];
                        putAllForItemCollection[itemKey + dataCollectionGuid].serverStatus         = 0;
                        putAllForItemCollection[itemKey + dataCollectionGuid].hasPosted            = 0;
                        putAllForItemCollection[itemKey + dataCollectionGuid].demographicResponses = itemType === "101" || itemType === "102"  ? itemResponses : [];
                        putAllForItemCollection[itemKey + dataCollectionGuid].dataCollectionGuid   = dataCollectionGuid;
                    }
                }
            }
        }
    } catch (error) {
        console.log("Exception: While handling the item response:_", error);
    }
}

export {
    processResponse,
    stringFormat,
    numberFormat,
    openEndStringFormat,
    processItemResponse,
    redirectionUrl
}
